import Vue from 'vue'

// v-html-static: come v-html, ma nel browser non riscrive l'HTML gia' arrivato dal server.
// Con v-html Vue, durante l'idratazione, riesegue sempre innerHTML anche se il contenuto
// e' identico: il nodo viene ricreato e, se e' l'elemento piu' grande (la descrizione
// dell'annuncio), il browser registra di nuovo l'LCP dopo l'avvio del JavaScript.
// Il lato server e' in nuxt.config.js (render.bundleRenderer.directives).

function write (el, value) {
  el.innerHTML = value == null ? '' : value
}

Vue.directive('html-static', {
  bind (el, { value }) {
    // In idratazione l'elemento arriva dal server gia' pieno: lo lasciamo com'e'.
    // Creato nel browser (es. navigazione verso un altro annuncio) e' vuoto: lo riempiamo.
    if (el.childNodes.length) { return }
    write(el, value)
  },
  update (el, { value, oldValue }) {
    // Riscrive solo se il contenuto cambia davvero (es. un altro annuncio nello stesso componente)
    if (value !== oldValue) { write(el, value) }
  }
})
